var { Platform } = require('react-native');
var Events = require('eventemitter3')
var RNDBModel = {};
RNDBModel.DBEvents = new Events()

var useDefaultData = false;
// useDefaultData = true;
var defaultData = {
  // "Features": {
  //   "Features--1":{
  //       "rowID" : "-1",
  //       "FeatureID": "3",
  //       "FeatureName": "Astarte Fresh Yogurt",
  //       "ImageFileName": "https:\/\/s3.amazonaws.com\/reup-web-storage\/6ba88\/news\/147384409705790te.jpg",
  //       "Description": "Come by to check out our always changing seasonal menu items!",
  //       "Timestamp": "2016-09-14 09:08:17",
  //       "IsDeleted": "0",
  //       "LocaleOverride": null
  //   }
  // },
  "Users": {
    "Users--1":{
            "UserID": "332",
            "UserName": "kjregan10@gmail.com",
            "Password": "asdfwxyzabcd",
            "FirstName": "Re",
            "LastName": "Up",
            "DOB": "0000-00-00",
            "ProfileURL": "",
            "Credit": "0.00",
            "Points": "0",
            "Verified": "1",
            "Admin": 0,
            "STRIPE_lastFour": "",
            "STRIPE_expMonth": "0",
            "STRIPE_expYear": "0",
            "STRIPE_cardType": "0",
            "PaymentInfo": "[]",
            "DirtyPassword": "0",
            "ReferralCode": "kelseyr332",
            "HasTransferredLoyalty": "0",
            "PhoneNumber": null,
            "AppStoreURL": "https:\/\/itunes.apple.com\/us\/app\/astarte\/id815879832?mt=8",
            "PlayStoreURL": "https:\/\/play.google.com\/store\/apps\/details?id=com.surepathmobile.astarte1&hl=en",
            "STRIPE_pubKey": "pk_live_1LMbvJ2hQjpEO4zahLVho2IZ",
            "DollarsPerPoint": "5",
            "PayPal_ClientID": "",
            "ShowPhoneNumber": false,
            "RequirePhoneForPurchase": false,
            "RequirePhoneForRewards": false,
            "RequirePhoneForPaymentTypes": false,
            "RequirePostalCode": false,
            "PayPal_Environment": "live",
            "CC_Gateway_Primary": "stripecc",
            "Hash": "5cb8ed9367",
            "PayMode": 0,
            "Locale": "en"
        }
      }
}

function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}

var isDemo = findGetParameter("isDemo");
if( isDemo != null ) useDefaultData = isDemo;

RNDBModel.create_db = function(db)
{
  var me = this;
  me.db_name = db;
  me.rows = {};
  var localItemsString = localStorage.getItem(db);
  if( typeof localItemsString !== undefined && localItemsString != null)
  {
    try {
      var newRows = JSON.parse(localItemsString);
      if( newRows ) me.rows = newRows;
    } catch (e) {
      console.log("couldn't parse local storage", localItemsString, e);
    } finally {

    }
  }
  if( useDefaultData && typeof defaultData[db] !== 'undefined' ) me.rows = defaultData[db];

  me.nextRowID = 0;

  /**
   * @description Finds all the objects based on the query
   * @param query_data
   * @param callback
   */
  me.get = function(query_data, callback)
  {
    callback([]); // dont use for now
      // ReactNativeStore.table(me.db_name).then(function(collection){
      //     var results = collection.where(query_data).find();
      //     if(callback){
      //         callback(results)
      //     }
      // });
  };

  /**
   * @description Finds by ID
   * @param id
   * @param callback
   */
  me.get_id = function(id, callback){
    callback({}) // dont use for now
  };

  /**
   * @description Gets all the data of the table
   * @param callback
   */
  me.get_all = function( callback){
    // if( useDefaultData && typeof defaultData[me.db_name] !== 'undefined' )
    // {
    //   console.log("using default " + me.db_name, defaultData[me.db_name])
    //   me.rows = defaultData[me.db_name];
    // }
    callback(me);
  };

  /**
   * @description Adds data to the Table in the DB
   * @param data_to_add
   * @param callback
   */
  me.add = function(data_to_add, callback){
    me.rows[me.db_name + (me.nextRowID++)] = data_to_add;
    me.backupRows();
    if( callback ) callback(data_to_add)
  };

  /**
   * @description Adds array of data to the Table in the DB
   * @param data_to_add
   * @param callback
   */
  me.add_all = function(data_to_add, callback){
      if(data_to_add.length <= 0) return null;

    var added_data = [];

    var addItem = function(data_to_add) {
      if(data_to_add.length == 0 && callback) { return callback(added_data); }
      var data = data_to_add.pop();

      me.add(data, function(data_added){
        addItem(data_to_add);
        added_data.push(data_added);
      });
    };

    addItem(data_to_add);
    if( callback ) callback(added_data);
  };

  /**
   * @description Removes all the objects matching the query
   * @param query_data
   * @param callback
   */
  me.remove = function(query_data, callback){
    callback(); // dont use
  };

  /**
   * @description Removed object by ID
   * @param id
   * @param callback
   */
  me.remove_id = function(id, callback){
    callback(); // dont use
  };

  /**
   * @description Erases the complete DB
   * @param callback
   */
  me.erase_db = function(callback){
    var copy = JSON.parse(JSON.stringify(me.rows));
    me.rows = {};
    me.backupRows();
    callback(copy);
  }
  /**
   * @description Updates the Table with the query
   * @param query_data
   * @param replace_data
   * @param callback
   */
  me.update = function(query_data, replace_data, callback)
  {
    var retRows = [];
    for( var i = 0; i < me.rows.length; i++ )
    {
      var isMatch = true;
      for( var key in query_data )
      {
        if( query_data[key] != me.rows[i][key] )
        {
          isMatch = false;
          break;
        }
      }

      if( isMatch )
      {
        for( var key in query_data )
        {
          me.rows[i][key] = replace_data[key];
        }
        retRows.push(me.rows[i]);
      }
    }
    if( callback ) callback(retRows);
  };

  /**
   * @description Updates the DB Object by ID
   * @param id
   * @param replace_data
   * @param callback
   */
  me.update_id = function(id, replace_data, callback){
    callback(); // dont use
  };

  /**
   * @description Removed object by ID
   * @param id
   * @param callback
   */
  me.remove_id = function(id, callback){
    callback(); // dont use
  };

  me.backupRows = function(){
    try {
      localStorage.setItem(me.db_name, JSON.stringify(me.rows));
    } catch (e) {
      console.log("problems saving to local storage", e)
    } finally {

    }
  }

};

module.exports = RNDBModel;
